import { writable } from 'svelte/store';
import { providers } from "ethers";
const _infura = "https://mainnet.infura.io/v3/f84d990aaff7469cbba62f68a40886ec";
//const _quiknode = Math.random() < 0.8 ? "https://red-snowy-bush.quiknode.pro/acb5cb49030080919f728dd0780d044a34ea454e/" : "https://silent-empty-bush.quiknode.pro/61f8b6928ec773d50c4c4438d915df57af1f2977/"
const rpcURL = _infura;
const arbiRPCURL = Math.random() < 0.9 ? "https://arb1.arbitrum.io/rpc" : "https://arb-mainnet.g.alchemy.com/v2/napRaNAJHBJH1zZq1AbHrWoZMd-eDSS5";
const WalletConnect = window.WalletConnect;
const LOCALSTORAGEKEY = "__doe_connection";
let _wcProvider;
export const ethereum = writable({
    rpc: new providers.JsonRpcProvider(rpcURL),
    chainId: 1,
});
export const ethPrice = writable("0.0");
export const clearWallet = () => {
    try {
        WalletConnect.disconnect();
    }
    catch (err) {
        console.error(err);
    }
    ethereum.update(_ethereum => (Object.assign(Object.assign({}, _ethereum), { signer: undefined, provider: new providers.JsonRpcProvider(rpcURL), address: undefined, chainId: 1 })));
    localStorage.removeItem(LOCALSTORAGEKEY);
    localStorage.removeItem("walletconnect");
};
export const connectBrowserSigner = async () => {
    if (window.ethereum == undefined)
        throw new Error("No ethereum object on window");
    // enable metamask, this can fail
    try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
    }
    catch (_a) {
        console.log("Wallet: Browser connection failed!");
        // clear any signer data
        clearWallet();
        return;
    }
    // setup callbacks
    window.ethereum.on('accountsChanged', connectBrowserSigner);
    window.ethereum.on('chainChanged', connectBrowserSigner);
    const provider = new providers.Web3Provider(window.ethereum);
    const chainId = (await provider.getNetwork()).chainId;
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    ethereum.update(_ethereum => (Object.assign(Object.assign({}, _ethereum), { signer,
        provider,
        address,
        chainId })));
    console.log("Wallet: Browser wallet connected!");
    localStorage.setItem(LOCALSTORAGEKEY, "metamask");
};
export const connectWalletConnect = async () => {
    const walletConnect = new WalletConnect({
        rpc: {
            1: rpcURL,
            42161: arbiRPCURL,
        },
        qrCode: true,
        pollingInterval: 30000
    });
    _wcProvider = await walletConnect.enable();
    const provider = new providers.Web3Provider(walletConnect);
    const chainId = (await provider.getNetwork()).chainId;
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    ethereum.update(_ethereum => (Object.assign(Object.assign({}, _ethereum), { signer,
        provider,
        address,
        chainId })));
    console.log("Wallet: Remote wallet connected!");
    localStorage.setItem(LOCALSTORAGEKEY, "walletconnect");
};
export const getBestProvider = (ethereum) => {
    if (ethereum.provider)
        return ethereum.provider;
    return ethereum.rpc;
};
export const fetchEthereumPrice = async () => {
    try {
        const res = await fetch("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD");
        const json = await res.json();
        ethPrice.set(json.USD);
    }
    catch (err) {
        console.error("could not get price.", err);
    }
};
export const reconnect = async () => {
    const method = localStorage.getItem(LOCALSTORAGEKEY);
    if (method == "metamask")
        return connectBrowserSigner();
    if (method == "walletconnect")
        return connectWalletConnect();
    localStorage.removeItem(LOCALSTORAGEKEY);
};
const init = async () => {
    reconnect();
};
init();
